import React from "react";
import { Box, Typography } from "@mui/material";

const CalendarLegend = ({ colorRules }) => {
  const formatLabel = (rule) => {
    if (rule.minSlots != null && rule.maxSlots != null) {
      return `${rule.minSlots}–${rule.maxSlots} slots`;
    }
    if (rule.minSlots != null) {
      return `${rule.minSlots}+ slots`;
    }
    if (rule.maxSlots != null) {
      return `${rule.maxSlots} or fewer slots`;
    }
    return "N/A";
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="flex-start"
      flexWrap="wrap"
      gap={3}
      mt={1}>
      {colorRules.map((rule, idx) => (
        <Box
          key={idx}
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={0.5}>
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              bgcolor: rule.color || "grey.500",
            }}
          />
          <Typography variant="caption" color="text.secondary" align="center">
            {rule.label || "Availability"}
            <Box
              component="span"
              sx={{ display: { xs: "none", sm: "inline" }, ml: 0.5 }}>
              ({formatLabel(rule)})
            </Box>
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              fontSize: "0.7rem",
              mt: "-2px",
              display: { xs: "block", sm: "none" },
            }}>
            ({formatLabel(rule)})
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default CalendarLegend;
